// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"572ac312","453":"6b157d80","531":"7e9088a8","570":"15ae74bf","855":"db8b282c"}[chunkId] + ".chunk.js";
};